import { Api } from "./Api.jsx";

export const newMessages = async () => {
  try {
    const response = await Api.post("/aeat/update");
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error reading new messages: ", error);
    throw error;
  }
};

export const updateReceipt = async (receiptId) => {
  try {
    const response = await Api.get(`/aeat/update/${receiptId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching receipts: ", error);
    throw error;
  }
};

export const postReceipts = async (receipts) => {
  try {
    const response = await Api.post("/aeat/accept", receipts);
    return response.data;
  } catch (error) {
    console.error("Error fetching receipts: ", error);
    throw error;
  }
};

export const fetchSilicie = async (receipts) => {
  try {
    const response = await Api.post("/aeat/silicie", receipts, { responseType: "blob" });
    return response.data;
  } catch (error) {
    console.error("Error fetching silicie: ", error);
    throw error;
  }
};
